import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plan",
  "use": "icon-plan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plan\"><path d=\"M384 336h368a40 40 0 0 0 0-80H384a40 40 0 0 0 0 80zM384 552h368a40 40 0 0 0 0-80H384a40 40 0 0 0 0 80zM384 768h368a40 40 0 0 0 0-80H384a40 40 0 0 0 0 80z\" p-id=\"20251\" /><path d=\"M890 64H198a70 70 0 0 0-70 70v58h80v-8a40 40 0 0 1 40-40h592a40 40 0 0 1 40 40v656a40 40 0 0 1-40 40H248a40 40 0 0 1-40-40v-8h-80v58a70 70 0 0 0 70 70h692a70 70 0 0 0 70-70V134a70 70 0 0 0-70-70z\" p-id=\"20252\" /><path d=\"M104 336h112a40 40 0 0 0 40-40 40 40 0 0 0-40-40H104a40 40 0 0 0-40 40 40 40 0 0 0 40 40zM128 440v144a40 40 0 0 0 80 0V440a40 40 0 0 0-80 0zM208 768h8a40 40 0 0 0 40-40 40 40 0 0 0-40-40H104a40 40 0 0 0-40 40 40 40 0 0 0 40 40h104z\" p-id=\"20253\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plan.svg
// module id = 0Ex+
// module chunks = 250